/**
 * Error text for the operator.
 *
 * DELIBERATELY INVERTED from the sibling project this was ported from. There,
 * sanitizeError is an allowlist: anything it does not recognise becomes
 * "Something went wrong. Please try again." That makes sense in front of an
 * Express/Sequelize backend, where a raw error can leak `ER_DUP_ENTRY` or a
 * connection string.
 *
 * It is the wrong default here. Every message this API produces is a sentence
 * someone wrote for an operator, and it names the way out:
 *
 *   "the enabled nordvpn accounts allow 18 simultaneous connections in total;
 *    14 are already committed to other groups, so at most 4 more"
 *
 * Replacing that with "Something went wrong" throws away the only useful part.
 * So: pass server messages through untouched, and translate only the handful of
 * TRANSPORT failures that come from fetch itself and are meaningless as-is.
 */

const TRANSPORT_MAPPINGS: Record<string, string> = {
  'Connection timeout': 'The request took too long. The control plane may be busy or unreachable.',
  'Failed to fetch': 'Could not reach the control plane. Is `python main.py` running?',
  NetworkError: 'Could not reach the control plane. Is `python main.py` running?',
  ENOTFOUND: 'Could not resolve the control plane address.',
  ECONNREFUSED: 'The control plane refused the connection.',
};

/** Shown only when there is genuinely nothing to report. */
export const GENERIC_ERROR_MESSAGE = 'The request failed, and the server gave no reason.';

export function sanitizeError(rawMessage: string): string {
  const message = (rawMessage ?? '').trim();
  if (!message) return GENERIC_ERROR_MESSAGE;

  for (const [needle, friendly] of Object.entries(TRANSPORT_MAPPINGS)) {
    if (message.toLowerCase().includes(needle.toLowerCase())) return friendly;
  }

  // Anything else came from the API and is already operator-facing.
  return message;
}
